module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/eko-piknik/thumbs/4-0ac514c3b5010aebb7da305aca280a84.webp";